export const BACKEND_URL = "https://formulare-schemmerhofen.de/ferienprogramm/backend_v102.php";
export const FRONTEND_SUB = "ferienprogramm";
